import { Routes, Route } from 'react-router-dom';

import AuthContainer from './containers/auth/Auth.container';
import DashboardContainer from './containers/dashboard/Dashboard.container';
import ShopContainer from './containers/shop/Shop.container';
import MarketContainer from './containers/market/Market.container';
import AdminContainer from './containers/admin/Admin.container';
import SocialLoginContainer from './containers/auth/social-login/SocialLogin.container';
import MyProfileContainer from './containers/my-profile/MyProfile.container';
import VerificationContainer from './containers/verification/Verification.container';
import HelpCenterContainer from './containers/help-center/HelpCenter.container';
import RegistrationContainer from './containers/auth/registration/Registration.container';
import InternalPasswordResetContainer from './containers/my-profile/internal-password-reset/InternalPasswordReset.container';
import ReportsContainer from './containers/reports/Reports.container';
import MyPreferencesContainer from './containers/my-preferences/MyPreferences.container';
import SystemNotices from './components/common/system-notices/SystemNotices';
import Spinner from './components/common/spinner/Spinner';

import AuthLayout from './layouts/auth-layout/AuthLayout';
import Layout from './layouts/Layout';

import './stylesheets/app.scss';

const App = () => {
  return (
    <div className="app">
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path="/*" element={<AuthContainer />} />
        </Route>
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<DashboardContainer />} />
          <Route path="/shop/*" element={<ShopContainer />} />
          <Route path="/market/*" element={<MarketContainer />} />
          <Route path="/my-profile" element={<MyProfileContainer />} />
          <Route path="/my-preferences" element={<MyPreferencesContainer />} />
          <Route path="/verification" element={<VerificationContainer />} />
          <Route path="/help-center/*" element={<HelpCenterContainer />} />
          <Route path="/internal-password-reset" element={<InternalPasswordResetContainer />} />
        </Route>
        <Route element={<Layout hideShortcuts />}>
          <Route path="/admin/*" element={<AdminContainer />} />
          <Route path="/reports/*" element={<ReportsContainer />} />
        </Route>
        <Route>
          <Route path="/registration/:personExternalReference" element={<RegistrationContainer />} />
          <Route path="/social-login/:type" element={<SocialLoginContainer />} />
        </Route>
      </Routes>
      <SystemNotices />
      <Spinner />
    </div>
  );
};

export default App;
